import React, { useState, useEffect } from 'react';
import { Tooltip } from 'react-tooltip';

// date imports
import { commentsData, commentTypes } from '../../data/captureCommentsExample';

export const CaptureCommentsModal = ({ user }) => {
	const [comments, setComments] = useState(commentsData);
	const [addingComment, setAddingComment] = useState(false);
	const [formValid, setFormValid] = useState(false);
	const initialCommentFormValue = {
		comment_type: 'Comment',
		comment_text: '',
		resolved: false,
		user: user,
		datetime: new Date().toISOString().slice(0, 19).replace('T', ' ')
	};
	const [commentFormValue, setCommentFormValue] = useState(
		initialCommentFormValue
	);

	useEffect(() => {
		checkFormValidity();
	}, [commentFormValue]);

	const addCommentToCapture = (e) => {
		e.preventDefault();

		setComments((prevComments) => [...prevComments, commentFormValue]);

		setCommentFormValue(initialCommentFormValue);
	};

	const checkFormValidity = () => {
		let valid = true;
		if (
			!commentFormValue.comment_type ||
			commentFormValue.comment_text.length === 0
		) {
			console.error('Missing comment type or text');
			valid = false;
		}

		setFormValid(valid);
	};

	return (
		<div
			className="modal modal-xl fade"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			id="viewCaptureCommentsModal"
			tabindex="-1"
			aria-labelledby="viewCaptureCommentsModalLabel"
			aria-hidden="true"
			style={{ marginTop: '80px', marginLeft: 'auto' }}
		>
				<div
				className="modal-dialog"
				style={{ width: '90vw', marginLeft: '10%' }}
			>
				<div className="modal-content" style={{ width: '80vw' }}>
				
					<div
						className="modal-header text-light"
						style={{ backgroundColor: 'rgb(48, 48, 48)' }}
					>
						<h5 className="modal-title" id="viewCaptureCommentsModalLabel">
							<i className="fa-solid fa-comments me-3"></i>Site comments
						</h5>
					</div>

					<div
						class="modal-body"
						style={{ maxHeight: '600px', overflowY: 'auto' }}
					>
						<h5>View comments for this capture on the table below.</h5>

						<div className="table-responsive mt-4">
							{/* className="captureCommentsTable" */}
							<table >
								<thead>
									<tr>
										<th>Date</th>
										<th>Raised by</th>
										<th>Type</th>
										<th>Comment</th>
										<th>Resolved</th>
										<th>Resolved by</th>
										<th>Resolved comment</th>
										<th>Resolved datetime</th>
									</tr>
								</thead>

								<tbody>
									{comments.map((comment, idx) => (
										<tr key={idx}>
											<td style={{ width: '15%' }}>{comment.datetime}</td>
											<td style={{ width: '10%' }}>{comment.raised_by}</td>
											<td style={{ width: '15%' }}>{comment.comment_type}</td>
											<td style={{ width: '25%' }}>{comment.comment_text}</td>
											<td style={{ width: '5%' }} className="text-center">
												{comment.resolved ? (
													<i className="fa-solid fa-circle-check"></i>
												) : (
													'-'
												)}
											</td>
											<td>
												{comment.resolved ? <>{comment.resolved_by}</> : '-'}
											</td>

											<td>
												{comment.resolved ? (
													<>{comment.resolved_comment}</>
												) : (
													'-'
												)}
											</td>

											<td>
												{comment.resolved ? (
													<>{comment.resolved_datetime}</>
												) : (
													'-'
												)}
											</td>
										</tr>
									))}

									<tr></tr>
									<tr></tr>
									<tr></tr>
									<tr></tr>

									<tr style={{ top: '50px', marginBottom: '10px' }}>
										<td colSpan={6} className="fw-bold fs-5">
											Add a new comment
										</td>
									</tr>

									<tr>
										<td>
											<input
												type="text"
												className="form-control"
												value={commentFormValue.datetime}
												disabled
											></input>
										</td>
										<td>
											<input
												type="text"
												className="form-control"
												value={commentFormValue.user}
												disabled
											></input>
										</td>
										<td className="d-flex justify-content-center">
											<select
												name="capture-comments-type"
												className="form-control"
												style={{ width: '80%' }}
												type="select"
												value={commentFormValue.comment_type}
												onChange={(e) =>
													setCommentFormValue({
														...commentFormValue,
														comment_type: e.target.value
													})
												}
											>
												{commentTypes.map((type) => (
													<option value={type}>{type}</option>
												))}
											</select>
											<sup>
												<i
													data-tooltip-id="comment-type-TT"
													className="fa-solid fa-circle-info text-secondary mx-2"
												></i>
											</sup>
										</td>
										<td>
											<input
												type="text"
												className="form-control"
												//style={{ fontStyle: 'italic', width: '100%', border: 'solid 1px grey', borderRadius: '3px', padding: '3px' }}
												value={commentFormValue.comment_text}
												onChange={(e) =>
													setCommentFormValue({
														...commentFormValue,
														comment_text: e.target.value
													})
												}
												placeholder="Add a comment"
											></input>
										</td>

										{/* <td>
											<select
												name="capture-comments-type"
                                                className="form-control"
												type="select"
												defaultValue={commentFormValue.resolved}
											>
												<option value={true}>True</option>
												<option value={false}>False</option>
											</select>
                                            <sup><i
												data-tooltip-id="comment-resolved-TT"
												className="fa-solid fa-circle-info text-secondary mx-2"
											></i></sup>
										</td> */}
										<td colSpan={2}>
											<button
												className="btn btn-small btn-secondary"
												onClick={
													formValid ? (e) => addCommentToCapture(e) : undefined
												}
												//disabled={!formValid}
												data-tooltip-id={!formValid && 'button-not-valid-TT'}
											>
												Add comment
											</button>
											<button className="noStyleButton"></button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<Tooltip id="button-not-valid-TT" place="top" effect="solid">
						There are missing fields in the form
					</Tooltip>

					<Tooltip id="comment-type-TT" place="top" effect="solid">
						<strong>Doubt</strong> - Flag this if you are uncertain or need
						clarification about something in this capture<br></br> <br></br>{' '}
						<strong>Concern</strong> - Flag this if you believe there might be a
						potential problem or risk with this capture <br></br> <br></br>{' '}
						<strong>Error</strong> - Flag this if you notice something incorrect
						in this capture<br></br>
						<br></br>
						<strong>Comment</strong> - Add a note with observations,
						suggestions, or extra information about this capture<br></br>{' '}
						<br></br> <strong>Correction</strong> - Flag this if you have a
						specific fix or improvement to suggest for this capture
					</Tooltip>

					<Tooltip id="comment-resolved-TT" place="top" effect="solid">
						Does
					</Tooltip>

					<div class="modal-footer">
						<>
							<button
								type="button"
								className="btn btn-secondary"
								data-bs-toggle="modal"
								data-bs-target="#viewCaptureCommentsModal"
							>
								Close
							</button>
						</>
					</div>
				</div>
			</div>
		</div>
	);
};
